import React, { useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import { API_URL_CONSTANTS } from '../../../constants/apiUrlConstants';
import {
  mob_paintathon_2021,
  mob_paintathon_2022,
  mob_paintathon_2024,
  mob_pain_winner,
  mobWinner,
} from '../../../constants/iconImageConstant';
import { Header } from '../../Header/Header';
import { Link } from 'react-router-dom';
import { Footer } from '../../appFooter/Footer';

interface SessionDetail {
  id: string;
  name: string;
  image: string;
  drawing: string;
  position: string;
}

export function MobPainwinList2021() {
  const [responseA, setResponseA] = useState<SessionDetail[]>([]);
  const [responseB, setResponseB] = useState<SessionDetail[]>([]);  const [selectedDrawing, setSelectedDrawing] = useState<string | null>(null);
  const [selectedDrawingName, setSelectedDrawingName] = useState<string | null>(null);
  const [showModal, setShowModal] = useState(false);
  const [yearData, setYearData] = useState<{ [year: string]: SessionDetail[] }>({});
  const [currentYear, setCurrentYear] = useState<string | null>(null);
  
  const url = API_URL_CONSTANTS.BASE_URL + API_URL_CONSTANTS.PAINTATHON_RESULT;

  const fetchPaintathonResult = useCallback(async (year: string) => {
   
    try {
      const res = await axios.post(
        url,
        { params: { year } },
        { headers: { 'Content-Type': 'application/json' } }
      );
      const data = res.data;
      setResponseA(data.A || []);
      setResponseB(data.B || []);
    } catch (error) {
      console.log('Error fetching data:', error);
    }
  }, [url]);

  useEffect(() => {
    if (currentYear) {
      fetchPaintathonResult(currentYear);
    }
  }, [currentYear, fetchPaintathonResult]);

  const handleYearSelect = (year: string) => {
    setCurrentYear(year);
  };

  const handleClick = (drawing: string, name: string) => {
    setSelectedDrawing(drawing);
    setSelectedDrawingName(name);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedDrawing(null);
    setSelectedDrawingName(null);
  };

 

  const ImageGroup = ({ title, group }: { title: string; group: SessionDetail[]; }) => (
    <>
      <h1>{title}</h1>
      <div className="win-container">
        <ul>
          {group.map((item) => (
            <li key={item.id} onClick={() => handleClick(item.drawing, item.name)}>
              <img src={`https://assets.etvbalbharat.com/${item.image}`} alt={item.name} loading="lazy"/>
            </li>
          ))}
        </ul>
      </div>
    </>
  );

  return (
    <>
      <Header />
      <div className="container-fluid mob-pain-winlist">
        {currentYear === null ? (
          <div className="col-md-12">
            <div className="mob-pain-winyrs">
              <img src={mobWinner} alt="Paintathon" width="100%" loading="lazy"/>
              <div className="mob-pain-yrs " >
                <ul>
                  <li onClick={() => handleYearSelect('2021')}>
                    <img src={mob_paintathon_2021} alt="Paintathon 2021" loading="lazy" />
                  </li>
                  <li>
                    <Link to="/paintathon-drawing-competition-2022" onClick={() => handleYearSelect('2022')}>
                      <img src={mob_paintathon_2022} alt="Paintathon 2022" loading="lazy" />
                    </Link>
                  </li>
                  <li>
                    <Link to="/paintathon-drawing-competition-2024" onClick={() => handleYearSelect('2024')}>
                      <img src={mob_paintathon_2024} alt="Paintathon 2024"  loading="lazy"/>
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        ) : (
          <div className="col-md-12">
            <div className="mob-pain-yrs21">
              <div className="yer-2021">
                <img src={mob_pain_winner} alt={`Paintathon ${currentYear}`} width="100%"  loading="lazy"/>
              </div>

              <div className="pain-winlist-box">
                <div className="col-md-12 ">
                  <span className="winlis-tit">Winner's List</span>
                </div>
                {responseA.length > 0 && (
              <ImageGroup title="Group A" group={responseA.slice(0, 3)} />
            )}
            {responseB.length > 0 && (
              <ImageGroup title="Group B" group={responseB.slice(0, 3)} />
            )}

                <div className="col-md-12">
                  <div className="artgal">
                    <Link to="paintathon-artist-gallerylist-2021">Artist Gallery</Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {/* Modal for Drawing */}
        {showModal && (
          <div className="modal fade show"  style={{ display: 'block', backgroundColor: 'rgba(0, 0, 0, 0.5)' }} onClick={closeModal}>
            <div className="modal-dialog" role="document">
              <div className="modal-content new-body">
                <div className="modal-header new-mod-head">
                  <button type="button" className="close" aria-label="Close" onClick={closeModal}>
                    &times;
                  </button>
                </div>
                <div className="modal-body">
                  <div className="container">
                    {selectedDrawing && (
                      <>
                        <img src={`https://assets.etvbalbharat.com/${selectedDrawing}`} width="100%" alt="Drawing" loading="lazy" />
                        {selectedDrawingName && (
                          <div className="drw-cand-name">{selectedDrawingName}</div>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <Footer />
    </>
  );
}














































































































































































































































































































